import { render, staticRenderFns } from "./CompanyChild.vue?vue&type=template&id=ad43a892&"
import script from "./CompanyChild.vue?vue&type=script&lang=js&"
export * from "./CompanyChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports